import { createApi } from "@reduxjs/toolkit/query/react";

import { createUrl } from "../utils";
import { ApiRoutes } from "../constants/ApiRoutes";
import { ApiMethod, fetchQuery } from "../helpers/ApiHelpers";
enum SurveyEnumApi {
  Strategy = "Strategy",
}
export const surveyApi = createApi({
  reducerPath: "surveyApi",
  baseQuery: fetchQuery(),
  tagTypes: [SurveyEnumApi.Strategy],

  endpoints: (builder) => ({
    generateSurveyCode: builder.mutation<void, void>({
      query: () => ApiRoutes.SurveyGenerateCode,
    }),
    getSurveyAnswers: builder.query<
      Application.ResponseProps<Survey.AnswerPrev[]>,
      { scenario: Survey.ScenarioType }
    >({
      query: (args) => {
        return createUrl(ApiRoutes.SurveyPreviousAnswers, { query: { scenario: args.scenario } });
      },
      providesTags: [SurveyEnumApi.Strategy],
    }),
    getSurveyData: builder.query<
      Application.ResponseProps<Survey.FormProps>,
      { scenario: Survey.ScenarioType }
    >({
      query: (args) => {
        return createUrl(ApiRoutes.SurveyData, {
          query: { scenario: args.scenario },
        });
      },
      providesTags: [SurveyEnumApi.Strategy],
    }),
    sendSurveyData: builder.mutation<void, Survey.SendSurveyItemsQueryProps>({
      query: (body) => ({
        url: ApiRoutes.SurveyData,
        method: ApiMethod.Post,
        body: body,
      }),
      invalidatesTags: [SurveyEnumApi.Strategy],
    }),
  }),
});

export const {
  useGetSurveyDataQuery,
  useLazyGetSurveyAnswersQuery,
  useSendSurveyDataMutation,
  useGenerateSurveyCodeMutation,
} = surveyApi;
